var NewTimeEvent = null
import request from "@/network/request"
import { isApp } from "./baseURL"
// import PublicApiUrl from "@/network/publicapi.js"
export default {
  install(Vue) {
    // 定义全局变量
    Vue.prototype.GlobalData = {
      OrgIdent: '党组织',
      PositionPrefix: '党委（县、市、区委、工委）'
    }
    // 通用路由跳转
    Vue.prototype.RouteGo = function (name, params) {
      //  检测是否是传入了一个function
      const isFunction = Object.prototype.toString.call(name) === "[object Function]";
      if (isFunction) {
        name()
        return
      }
      // 检测当前是否是一个路由
      const isLink = name === null || name === "" ? false : true
      // 检测当前是否是外链,正则语法剔除HTTPS://或HTTP://开头的，且不区分大小写
      const rules = /^((https|http)?:\/\/)[^\s]+/;
      const isOutSite = rules.test(name)
      // 如果传了NAME过来形成了路由，且不指向外部链接，就调用动态路由匹配
      if (isLink && !isOutSite) {
        this.$router.push({
          name: name,
          params: params
        })
      }
      // 如果是外链，就新窗口打开
      else if (isLink && isOutSite) {
        window.open(name)
      }
      //  如果不是路由就随便撸一发方便测试
      else {
        console.log("您点击了一个非路由非函数的空元素")
      }
    }

    //  一般访问接口公共方法
    Vue.prototype.PublicApi = function (url, data, methods, passerr = false) {
      if (!!methods && methods === 'get') {
        return request.get(url, data, {
          passerr: passerr,
        })

      } else {
        return request.post(url, data, {
          passerr: passerr,

        })
      }
    }

    //  数据接口返回时的提示
    Vue.prototype.DataTip = function (status, msg) {
      let popname
      msg = msg ? msg : "请查看控制台报错信息"
      popname = status === 200 ? "success" : "error"
      this.$message({
        message: msg,
        type: popname
      });
    }



    //  统计全屏展示
    Vue.prototype.FullScreen = function (e) {
      let $el = $(e.target.parentElement)
      let $btn = $(e.target)
      if ($el.hasClass("tj_fullscreen")) {
        $el.removeClass("tj_fullscreen")
        $(e.target).css({
          top: "140px",
          right: "60px"
        }).text("全屏展示")
      } else {
        $el.addClass("tj_fullscreen")
        $(e.target).css({
          top: "10px",
          right: "10px"
        }).text("取消全屏")
      }

      // 检测是否全屏状态，如果不是就开启全屏，否则取消全屏
      // $el.css({
      //   position:"fixed",
      //   width:"100%",
      //   height:"100%",
      //   left:0,
      //   top:0
      // })


      // e.target.parentElement
    }

    // 公共设置session方法，防止标签页sessionStorage不共享
    Vue.prototype.$setSession = function (name, value) {
      if (window.opener && Object.getOwnPropertyNames(window.opener).length > 0) {
        window.opener.sessionStorage.setItem(name, value)
      } else {
        sessionStorage.setItem(name, value)
      }
    }
    // 取sessionStorage
    Vue.prototype.$getSession = function (name) {
      if (window.opener && Object.getOwnPropertyNames(window.opener).length > 0) {
        return window.opener.sessionStorage.getItem(name)
      } else {
        return sessionStorage.getItem(name)
      }
    }

    // 取得当前时间
    Vue.prototype.getMyDate = function () {
      let date = new Date()
      date = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        // day : date.getDate(),
        hours: date.getHours(),
        minutes: date.getMinutes(),
        seconds: date.getSeconds(),
        day: date.getDay()
      }
      return date
    }

    // 公共资源网
    Vue.prototype.publicWeb = function () {
      const Web = {
        url: 'https://studyadmin.chinahc.wang'
      }
      return Web
    }

    // 时间格式化
    Vue.prototype.parseTime = function (time, cFormat) {
      if (arguments.length === 0 || !time) {
        return null
      }
      const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if ((typeof time === 'string')) {
          if ((/^[0-9]+$/.test(time))) {
            // support "1548221490638"
            time = parseInt(time)
          } else {
            // support safari
            // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
            time = time.replace(new RegExp(/-/gm), '/')
          }
        }

        if ((typeof time === 'number') && (time.toString().length === 10)) {
          time = time * 1000
        }
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }
      const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
          return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        return value.toString().padStart(2, '0')
      })
      return time_str
    }

    // 格式化性别
    Vue.prototype.format = (value) => {
      switch (value) {
        case 1:
          value = "男"
          break
        case 2:
          value = "女"
          break
        case 3:
          value = "是"
          break
        case 4:
          value = "否"
          break
        default:
          value = ""
      }
      return value
    }

    // 格式化认证状态
    Vue.prototype.identFormat = (value) => {
      switch (value) {
        case 1:
          value = "待认证"
          break
        case 2:
          value = "已认证"
          break
        case 3:
          value = "认证失败"
          break
        case 4:
          value = "认证中"
          break
        default:
          value = ""
      }
      return value
    }


    // 图片上传组件公共格式化方法
    Vue.prototype.rebuildUrl = (url) => {
      const type = url.slice(url.lastIndexOf(".") + 1)
      let wordType = ['doc', 'docx']
      let pdfType = ['pdf', 'pdfx']
      let pptType = ['ppt', 'pptx']
      let excelType = ['xls', 'xlsx', 'csv']
      let videoType = ['mp4', 'rmvb', 'flv', 'avi', 'mov', 'rm', 'rmvb', '3gp']
      let musicType = ['mp3', 'ogg', 'acc', 'ape', 'wav', 'wma']
      let imgType = ['jpeg', 'gif', 'jpg', 'png', 'bmp', 'webp', 'svg']
      wordType.forEach(res => {
        if (res === type) {
          url = "https://info.chinahc.wang/1617967910518_word_icon.png"
        }
      })
      imgType.forEach(res => {
        if (res === type) {
          url = url
        }
      })
      pdfType.forEach(res => {
        if (res === type) {
          url = "https://info.chinahc.wang/1617967910514_pdf_icon.png"
        }
      })
      pptType.forEach(res => {
        if (res === type) {
          url = "https://info.chinahc.wang/1617968430023_ppt_icon.png"
        }
      })
      excelType.forEach(res => {
        if (res === type) {
          url = "https://info.chinahc.wang/1617968430021_excel_icon.png"
        }
      })
      videoType.forEach(res => {
        if (res === type) {
          url = url + "?vframe/jpg/offset/1"
        }
      })
      musicType.forEach(res => {
        if (res === type) {
          url = "https://info.chinahc.wang/1617968524283_mp3_icon.png"
        }
      })
      return url
    }

    // 设置文件格式并根据文件格式展示不同的图片
    Vue.prototype.freeStyle = (url) => {
      // 设置文件格式默认为图片
      let real_url = url
      let read_url = url
      let old_url = url
      let filetype = "image"
      // 获取文件后缀
      const type = url.slice(url.lastIndexOf(".") + 1)
      // 判断是否word
      const wordType = ["doc", "docx"]
      wordType.forEach(res => {
        if (type === res) {
          real_url = "https://info.chinahc.wang/1617967910518_word_icon.png"
          read_url = "http://view.officeapps.live.com/op/view.aspx?src=" + url
          filetype = "office"
          old_url = "http://view.officeapps.live.com/op/view.aspx?src=" + url
          return
        }
      })
      // 判断是否excel
      const excelType = ["xls", "xlsx"]
      excelType.forEach(res => {
        if (type === res) {
          real_url = "https://info.chinahc.wang/1617968430021_excel_icon.png"
          read_url = "http://view.officeapps.live.com/op/view.aspx?src=" + url
          filetype = "office"
          old_url = "http://view.officeapps.live.com/op/view.aspx?src=" + url
          return
        }
      })
      // 判断是否word
      const pptType = ["ppt", "pptx"]
      pptType.forEach(res => {
        if (type === res) {
          real_url = "https://info.chinahc.wang/1617968430023_ppt_icon.png"
          read_url = "http://view.officeapps.live.com/op/view.aspx?src=" + url
          filetype = "office"
          old_url = "http://view.officeapps.live.com/op/view.aspx?src=" + url
          return
        }
      })
      // 判断是否pdf
      const pdfType = ["pdf", "pdfx"]
      pdfType.forEach(res => {
        if (type === res) {
          real_url = "https://info.chinahc.wang/1617967910514_pdf_icon.png"
          // read_url = url
          read_url = "https://web.chinahc.wang/pdf/web/viewer.html?file=" + url
          filetype = "office"
          old_url = url
          return
        }
      })
      // 判断是否是视频AVI、mov、rmvb、rm、FLV、mp4、3GP
      const videoType = ["mp4", "rmvb", "flv", "avi", "mov", "3gp", "rm"]
      videoType.forEach(res => {
        if (type === res) {
          real_url = url + "?vframe/jpg/offset/1"
          read_url = url
          filetype = "video"
          old_url = url
          return
        }
      })

      //判断是否是图片文件
      const imgType = ["jpg", "jpeg", "gif", "bmp", "tif", "webp", "svg", "pcx", "wmf"]
      imgType.forEach(res => {
        if (type === res) {
          real_url = url
          read_url = url
          filetype = "image"
          old_url = url
          return
        }
      })

      // 装进一个统一对象输出
      url = {
        real_url: real_url,
        read_url: read_url,
        filetype: filetype,
        old_url: old_url
      }

      return url
    }
    // 预览文件操作处理
    Vue.prototype.FilePreview = (url) => new Promise(resolve => {
      const that = this
      setTimeout(() => {
        let gs = url.lastIndexOf(".")
        gs = url.slice(gs + 1)
        // 视频
        let isVideo = false
        let videoType = "mp4,rmvb,flv,avi,mov,3gp,rm"
        videoType = videoType.split(",")
        videoType.forEach(res => {
          if (res === gs) {
            isVideo = true
          }
        })
        // 图片
        let isImage = false
        let imageType = "jpg,jpeg,gif,bmp,tif,webp,svg,pcx,wmf,png"
        imageType = imageType.split(",")
        imageType.forEach(res => {
          if (res === gs) {
            isImage = true
          }
        })
        // OFFICE文档
        let isOffice = false
        let officeType = "xls,xlsx,xlsb,xlsm,xlst,csv,doc,docx,ppt,pptx"
        officeType = officeType.split(",")
        officeType.forEach(res => {
          if (res === gs) {
            isOffice = true
          }
        })
        // 音频
        let isMusic = false
        let musicType = "mp3,ogg,acc,ape,wav,wma"
        musicType = musicType.split(",")
        musicType.forEach(res => {
          if (res === gs) {
            isMusic = true
          }
        })
        // PDF文档
        let isPDF = false
        let PDFType = "pdf,pdfx"
        PDFType = PDFType.split(",")
        PDFType.forEach(res => {
          if (res === gs) {
            isPDF = true
          }
        })
        //开始判断文件类型，显示不同的弹窗
        if (isPDF) {
          const fileurl = url
          let bg = document.createElement("div")
          bg.className = "framebg"
          bg.id = "framebg"

          // return new Promise((resolve, reject) => {
          //   try {
          //     let blob = null;
          //     let xhr = new XMLHttpRequest();
          //     xhr.open("GET", fileurl);
          //     xhr.responseType = "blob";
          //     xhr.onload = () => {
          //       blob = xhr.response;
          //       const blobob = new Blob([blob], { type: 'application/pdf' });
          //       let href = null
          //       if (window.createObjectURL !== undefined) {
          //         href = window.createObjectURL(blobob)
          //       } else if (window.webkitURL !== undefined) {
          //         try {
          //           href = window.webkitURL.createObjectURL(blobob)
          //         } catch (err) {
          //           alert(err)
          //         }
          //       } else if (window.URL !== undefined) {
          //         try {
          //           href = window.URL.createObjectURL(blobob)
          //         } catch (err) {
          //           alert(err)
          //         }
          //       }
          //       // const href = window.URL.createObjectURL(blobob);
          //       // alert(href);
          //       // window.open(href, 'newWindow');
          //       let frame = document.createElement("iframe")
          //       frame.id = "fileframe"
          //       frame.className = "fileframe"
          //       frame.src = href
          //       let closer = document.createElement("div")
          //       closer.className = "framecloser"
          //       closer.id = "framecloser"
          //       bg.onclick = function () {
          //         $(bg).remove()
          //         $(frame).remove()
          //         $(closer).remove()
          //       }
          //       closer.onclick = function () {
          //         $(bg).remove()
          //         $(frame).remove()
          //         $(closer).remove()
          //       }

          //       document.body.append(bg)
          //       document.body.append(frame)
          //       document.body.append(closer)
          //       // resolve(file);
          //     };
          //     xhr.onerror = (e) => {
          //       reject(e)
          //     };
          //     xhr.send();
          //   } catch (error) {
          //     alert(error)
          //   }

          // });
          // return 1;


          // path是文件的全路径地址
          // window.open('/pdf/web/viewer.html?file=' + fileurl)
          //app端预览
          let src='';
          if (isApp == 1) {
             src = "https://web.chinahc.wang/pdf/web/viewer.html?file=" + fileurl
          } else {
              src = fileurl
          }

          // pc端预览

          let frame = document.createElement("iframe")
          frame.id = "fileframe"
          frame.className = "fileframe"
          frame.src = src
          let closer = document.createElement("div")
          closer.className = "framecloser"
          closer.id = "framecloser"
          bg.onclick = function () {
            $(bg).remove()
            $(frame).remove()
            $(closer).remove()
          }
          closer.onclick = function () {
            $(bg).remove()
            $(frame).remove()
            $(closer).remove()
          }

          document.body.append(bg)
          document.body.append(frame)
          document.body.append(closer)
        }

        if (isOffice) {
          const fileurl = url
          let bg = document.createElement("div")
          bg.className = "framebg"
          bg.id = "framebg"
          const src = "https://view.officeapps.live.com/op/view.aspx?src=" + fileurl
          // console.log(fileurl.slice(file.url.lastIndexOf(".") + 1))

          // const src = fileurl
          let frame = document.createElement("iframe")
          frame.id = "fileframe"
          frame.className = "fileframe"
          frame.src = src
          let closer = document.createElement("div")
          closer.className = "framecloser"
          closer.id = "framecloser"
          bg.onclick = function () {
            $(bg).remove()
            $(frame).remove()
            $(closer).remove()
          }
          closer.onclick = function () {
            $(bg).remove()
            $(frame).remove()
            $(closer).remove()
          }
          document.body.append(bg)
          document.body.append(frame)
          document.body.append(closer)
        }
        if (isImage) {
          // 文件类型为图片格式,返回交页面处理
          resolve('imgType')
        }
        if (isVideo) {
          const fileurl = url
          let bg = document.createElement("div")
          bg.className = "framebg"
          bg.id = "framebg"
          const src = fileurl
          // const src = fileurl
          let videoBox = document.createElement("div")
          videoBox.className = "popup_video_box"
          videoBox.id = "popupVideoBox"

          let video = document.createElement("video")
          video.id = "fileframes"
          video.className = "fileframes"
          video.src = src
          video.controls = "controls"

          video.style.marginTop = (window.screen.height - 400) / 2 + 'px'

          let closer = document.createElement("div")
          closer.className = "framecloser"
          closer.id = "framecloser"
          bg.onclick = function () {
            $(bg).remove()
            $(video).remove()
            $(videoBox).remove()
            $(closer).remove()
          }
          closer.onclick = function () {
            $(bg).remove()
            $(video).remove()
            $(videoBox).remove()
            $(closer).remove()
          }
          document.body.append(bg)
          videoBox.append(video)
          document.body.append(videoBox)
          document.body.append(closer)

        }

        if (isMusic) {
          $("#audio").remove()
          $("#fileframe").remove()
          $("#framecloser").remove()
          $("#popupVideoBox").remove()
          const fileurl = url
          const src = fileurl
          // const src = fileurl
          let videoBox = document.createElement("div")
          videoBox.className = "popup_video_box"
          videoBox.id = "popupVideoBox"
          let video = document.createElement("audio")
          video.id = "audio"
          video.className = ""
          video.src = src
          video.controls = "controls"
          video.autoplay = "true"
          video.style.width = "600px"
          video.style.height = "80px"
          video.style.position = "fixed"
          video.style.bottom = "0"
          video.style.left = "50%"
          video.style.top = "auto"
          video.style.marginLeft = "-300px"
          let closer = document.createElement("div")
          closer.className = "framecloser"
          closer.id = "framecloser"
          closer.style.top = "auto"
          closer.style.bottom = "33px"
          closer.style.left = "50%"
          closer.style.marginLeft = "280px"
          closer.onclick = function () {
            $(video).remove()
            $(videoBox).remove()
            $(closer).remove()
          }
          videoBox.append(video)
          document.body.append(videoBox)
          document.body.append(closer)
        }
      })
    })

    // 格式化小写数字为大写
    Vue.prototype.toChinese = (Num) => {
      for (let i = Num.length - 1; i >= 0; i--) {
        Num = Num.replace(",", ""); //替换Num中的“,”
        Num = Num.replace(" ", ""); //替换Num中的空格
      }
      if (isNaN(Num)) {
        //验证输入的字符是否为数字
        return;
      }
      //字符处理完毕后开始转换，采用前后两部分分别转换
      let part = String(Num).split(".");
      let newchar = "";
      //小数点前进行转化
      for (let i = part[0].length - 1; i >= 0; i--) {
        if (part[0].length > 10) {
          //十位数以上就取消转换
          console.log("数字太大，如非必要，不做后续处理了");
          return "";
        }
        let tmpnewchar = "";
        let perchar = part[0].charAt(i);
        //统一转换并添加单位，下一步进行逐步替换
        switch (perchar) {
          case "0":
            tmpnewchar = "零" + tmpnewchar;
            break;
          case "1":
            tmpnewchar = "一" + tmpnewchar;
            break;
          case "2":
            tmpnewchar = "二" + tmpnewchar;
            break;
          case "3":
            tmpnewchar = "三" + tmpnewchar;
            break;
          case "4":
            tmpnewchar = "四" + tmpnewchar;
            break;
          case "5":
            tmpnewchar = "五" + tmpnewchar;
            break;
          case "6":
            tmpnewchar = "六" + tmpnewchar;
            break;
          case "7":
            tmpnewchar = "七" + tmpnewchar;
            break;
          case "8":
            tmpnewchar = "八" + tmpnewchar;
            break;
          case "9":
            tmpnewchar = "九" + tmpnewchar;
            break;
        }

        //多位数添加单位
        switch (part[0].length - i - 1) {
          case 0:
            tmpnewchar = tmpnewchar;
            break;
          case 1:
            if (perchar != 0) tmpnewchar = tmpnewchar + "十";
            break;
          case 2:
            if (perchar != 0) tmpnewchar = tmpnewchar + "百";
            break;
          case 3:
            if (perchar != 0) tmpnewchar = tmpnewchar + "千";
            break;
          case 4:
            tmpnewchar = tmpnewchar + "万";
            break;
          case 5:
            if (perchar != 0) tmpnewchar = tmpnewchar + "十";
            break;
          case 6:
            if (perchar != 0) tmpnewchar = tmpnewchar + "百";
            break;
          case 7:
            if (perchar != 0) tmpnewchar = tmpnewchar + "千";
            break;
          case 8:
            tmpnewchar = tmpnewchar + "亿";
            break;
          case 9:
            tmpnewchar = tmpnewchar + "十";
            break;
        }
        newchar = tmpnewchar + newchar;
      }
      //替换掉无用大写数字
      while (
        newchar.search("零零") != -1 ||
        newchar.search("零亿") != -1 ||
        newchar.search("亿万") != -1 ||
        newchar.search("零万") != -1
      ) {
        newchar = newchar.replace("零亿", "亿");
        newchar = newchar.replace("亿万", "亿");
        newchar = newchar.replace("零万", "万");
        newchar = newchar.replace("零零", "零");
      }
      //替换以“一十”开头的，为“十”
      if (newchar.indexOf("一十") == 0) {
        newchar = newchar.substr(1);
      }
      //替换以“零”结尾的，为“”
      if (newchar.lastIndexOf("零") == newchar.length - 1) {
        newchar = newchar.substr(0, newchar.length - 1);
      }
      return newchar;
    }
  }

}



// WEBPACK FOOTER //
// ./src/assets/js/public.js